<template>
    <div class="advisor-weekly-sidebar">
        <div class="weekly-panel-card student-card" v-if="data.student">
            <div class="weekly-card-title student-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>
                <span>Öğrenci</span>
            </div>
            <div class="student-row">
                <img :src="studentAvatar" :alt="data.student.fullName" />
                <div>
                    <strong>{{ data.student.fullName }}</strong>
                    <small v-if="studentMeta">{{ studentMeta }}</small>
                </div>
            </div>
        </div>

        <div class="weekly-panel-card summary-card">
            <div class="weekly-card-title blue-title"><svg data-v-e566d5b2="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-e566d5b2="" d="M10.0001 13.3333V17.5M13.3334 12.1992V17.5M16.6667 8.88V17.5M18.3334 2.5L11.1284 9.705C11.0897 9.7438 11.0437 9.77459 10.9931 9.79559C10.9425 9.8166 10.8882 9.82741 10.8334 9.82741C10.7786 9.82741 10.7243 9.8166 10.6737 9.79559C10.6231 9.77459 10.5771 9.7438 10.5384 9.705L7.79508 6.96167C7.71694 6.88355 7.61098 6.83967 7.5005 6.83967C7.39001 6.83967 7.28405 6.88355 7.20591 6.96167L1.66675 12.5M3.33341 15.3858V17.5M6.66675 12.2133V17.5" stroke="#3478F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg><span>Haftalık Özet</span></div>
            <div class="summary-grid">
                <div class="summary-box purple"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M13 23.8333V13M13 13L3.56417 7.58333M13 13L22.4358 7.58333M8.125 4.62583L17.875 10.205M11.9167 23.5408C12.246 23.731 12.6197 23.8311 13 23.8311C13.3803 23.8311 13.754 23.731 14.0833 23.5408L21.6667 19.2075C21.9957 19.0175 22.269 18.7444 22.4592 18.4154C22.6493 18.0865 22.7496 17.7133 22.75 17.3333V8.66667C22.7496 8.28671 22.6493 7.91354 22.4592 7.58459C22.269 7.25564 21.9957 6.98248 21.6667 6.7925L14.0833 2.45917C13.754 2.269 13.3803 2.16889 13 2.16889C12.6197 2.16889 12.246 2.269 11.9167 2.45917L4.33333 6.7925C4.00428 6.98248 3.73098 7.25564 3.54083 7.58459C3.35069 7.91354 3.25039 8.28671 3.25 8.66667V17.3333C3.25039 17.7133 3.35069 18.0865 3.54083 18.4154C3.73098 18.7444 4.00428 19.0175 4.33333 19.2075L11.9167 23.5408Z" stroke="#8E42D8" stroke-width="2.16667"/></svg><span>Ders</span><strong>{{ C.Int(data.subjectCount) }}</strong></div>
                <div class="summary-box blue"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M17.3333 4.33333H19.4999C20.0746 4.33333 20.6257 4.56161 21.032 4.96793C21.4383 5.37426 21.6666 5.92536 21.6666 6.5V21.6667C21.6666 22.2413 21.4383 22.7924 21.032 23.1987C20.6257 23.6051 20.0746 23.8333 19.4999 23.8333H6.49992C5.92528 23.8333 5.37418 23.6051 4.96785 23.1987C4.56153 22.7924 4.33325 22.2413 4.33325 21.6667V6.5C4.33325 5.92536 4.56153 5.37426 4.96785 4.96793C5.37418 4.56161 5.92528 4.33333 6.49992 4.33333H8.66659M9.74992 15.1667L11.9166 17.3333L16.2499 13M9.74992 2.16667H16.2499C16.8482 2.16667 17.3333 2.65169 17.3333 3.25V5.41667C17.3333 6.01497 16.8482 6.5 16.2499 6.5H9.74992C9.15161 6.5 8.66658 6.01497 8.66658 5.41667V3.25C8.66658 2.65169 9.15161 2.16667 9.74992 2.16667Z" stroke="#2F86E9" stroke-width="2.16667"/></svg><span>Konu</span><strong>{{ C.Int(data.taskCount) }}</strong></div>
                <div class="summary-box green"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M22.75 5.41667H3.25M7.58333 13H3.25M7.58333 20.5833H3.25M13 19.5C13.6821 20.4095 14.6331 21.0813 15.7183 21.4203C16.8034 21.7593 17.9677 21.7482 19.0462 21.3887C20.1248 21.0292 21.0628 20.3395 21.7276 19.4172C22.3923 18.4949 22.75 17.3869 22.75 16.25C22.75 14.9571 22.2364 13.7171 21.3221 12.8029C20.4079 11.8886 19.1679 11.375 17.875 11.375C16.4342 11.375 15.1233 11.96 14.1808 12.9025L11.9167 15.1667M16.25 15.1667H11.9167V10.8333" stroke="#29AE73" stroke-width="2.16667"/></svg><span>KBS</span><strong>{{ C.Int(data.kbsCount) }}</strong></div>
                <div class="summary-box orange"><svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M13.0001 23.8333C18.9832 23.8333 23.8334 18.9831 23.8334 13C23.8334 7.01692 18.9832 2.16667 13.0001 2.16667C7.017 2.16667 2.16675 7.01692 2.16675 13C2.16675 18.9831 7.017 23.8333 13.0001 23.8333Z" stroke="#FF8A19" stroke-width="2.16667"/><path d="M13.0001 19.5C16.5899 19.5 19.5001 16.5899 19.5001 13C19.5001 9.41015 16.5899 6.5 13.0001 6.5C9.41023 6.5 6.50008 9.41015 6.50008 13C6.50008 16.5899 9.41023 19.5 13.0001 19.5Z" stroke="#FF8A19" stroke-width="2.16667"/><path d="M13.0001 15.1667C14.1967 15.1667 15.1667 14.1966 15.1667 13C15.1667 11.8034 14.1967 10.8333 13.0001 10.8333C11.8035 10.8333 10.8334 11.8034 10.8334 13C10.8334 14.1966 11.8035 15.1667 13.0001 15.1667Z" stroke="#FF8A19" stroke-width="2.16667"/></svg><span>Planlanan Gün</span><strong>{{ C.Int(data.plannedDayCount) }}/7</strong></div>
            </div>
        </div>

        <div class="weekly-panel-card work-card">
            <button type="button" class="work-add-btn" aria-label="Çalışma süresi ekle" title="Çalışma süresi ekle" @click.stop="$emit('open-work-modal')" >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 5V19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
            <div class="weekly-card-title purple-title">
                <svg data-v-e566d5b2="" width="16" height="16" viewBox="0 0 20 20" fill="none"><path data-v-e566d5b2="" d="M10 5V10L13.3333 11.6667M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="#7B28D8" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                <span>Haftalık Çalışılan Süre</span>
            </div>
            <div class="value-row">
                <div class="metric-values">
                    <strong class="metric-current">{{ appData.fn.getHour(workTotal) }}</strong>
                    <span class="metric-target">/ {{ appData.fn.getHour(data.workMaxCount) }}</span>
                    <small>Saat</small>
                </div>
                <span class="change" :class="C.Int(data.workCountChange) >= 0 ? 'positive' : 'negative'">
                    {{ C.Int(data.workCountChange) >= 0 ? '▲' : '▼' }} %{{ Math.abs(Math.round(C.Int(data.workCountChange))) }}
                    <small>geçen haftaya göre</small>
                </span>
            </div>
            <div class="bar-area">
                <span v-for="day in workDays" :key="day.name" :style="{ height: Math.max(10, (day.value / workMax) * 100) + '%' }"></span>
            </div>
            <div class="day-labels"><span v-for="day in workDays" :key="day.name">{{ day.name }}</span></div>
        </div>

        <div class="weekly-panel-card question-card">
            <div class="weekly-card-title orange-title"><svg data-v-e566d5b2="" width="16" height="16" viewBox="0 0 20 20" fill="none"><path data-v-e566d5b2="" d="M13.3333 3.33333H15C15.4419 3.33333 15.8659 3.50893 16.1785 3.82149C16.4911 4.13405 16.6667 4.55797 16.6667 5V6.66667M6.66667 18.3333H5C4.558 18.3333 4.13405 18.1577 3.82149 17.8452C3.50893 17.5326 3.33333 17.1087 3.33333 16.6667V5C3.33333 4.55797 3.50893 4.13405 3.82149 3.82149C4.13405 3.50893 4.558 3.33333 5 3.33333H6.66667M17.7892 13.0525C17.9535 12.8882 18.0839 12.6931 18.1728 12.4784C18.2617 12.2636 18.3075 12.0334 18.3075 11.8008C18.3075 11.5683 18.2617 11.3381 18.1728 11.1233C18.0839 10.9086 17.9535 10.7135 17.7892 10.5492C17.6248 10.3849 17.4297 10.2545 17.215 10.1656C17.0002 10.0767 16.77 10.0309 16.5375 10.0309C16.3049 10.0309 16.0747 10.0767 15.86 10.1656C15.6452 10.2545 15.4501 10.3849 15.2858 10.5492L11.1117 14.725C10.9136 14.9229 10.7686 15.1677 10.69 15.4367L9.9928 17.8271C9.9719 17.8988 9.97064 17.9748 9.98918 18.0472C10.0077 18.1195 10.0454 18.1855 10.0982 18.2384C10.151 18.2912 10.2171 18.3289 10.2894 18.3474C10.3618 18.3659 10.4378 18.3647 10.5095 18.3438L12.8999 17.6465C13.1689 17.568 13.4136 17.423 13.6117 17.225L17.7892 13.0525ZM7.5 1.66667H12.5C12.9602 1.66667 13.3333 2.03976 13.3333 2.5V4.16667C13.3333 4.6269 12.9602 5 12.5 5H7.5C7.03976 5 6.66667 4.6269 6.66667 4.16667V2.5C6.66667 2.03976 7.03976 1.66667 7.5 1.66667Z" stroke="#FF7B0A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg><span>Haftalık Çözülen Soru</span></div>
            <div class="value-row">
                <div class="metric-values">
                    <strong class="metric-current">{{ C.Int(data.questionCount) }}</strong>
                    <span class="metric-target">/ {{ C.Int(data.questionMaxCount) }}</span>
                    <small>Soru</small>
                </div>
                <span class="change" :class="C.Int(data.questionCountChange) >= 0 ? 'positive' : 'negative'">
                    {{ C.Int(data.questionCountChange) >= 0 ? '▲' : '▼' }} %{{ Math.abs(Math.round(C.Int(data.questionCountChange))) }}
                    <small>geçen haftaya göre</small>
                </span>
            </div>
            <div class="question-area">
                <div class="donut" :style="donutStyle"><span>{{ C.Int(data.questionCount) }}<small>Toplam</small></span></div>
                <div class="legend">
                    <span><i class="correct"></i>Doğru <b>{{ questionSummary.correct }}</b></span>
                    <span><i class="wrong"></i>Yanlış <b>{{ questionSummary.wrong }}</b></span>
                    <span><i class="empty"></i>Boş <b>{{ questionSummary.empty }}</b></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { computed } from "vue";
import { appData, C, D, J } from "@/helpers/global";
import { Constants } from "@/helpers/constants";
import { Enums } from "@/helpers/enums";
import { Web } from "@/helpers/web";
import avatarStudentBoy from "@/assets/img/avatar-student-boy.png";
import avatarStudentGirl from "@/assets/img/avatar-student-girl.png";
import avatarStudentDefault from "@/assets/img/avatar-student-default.png";

export default {
    name: "WeeklyPlanSidebar",
    emits: ["open-work-modal"],
    props: { data: { type: Object, required: true } },
    setup(props) {
        const studentAvatar = computed(() => {
            const student = props.data.student || {};
            const gender = C.Str(student.gender || student.genderName || student.genderType || student.sex).toLocaleLowerCase("tr-TR");
            const genderId = C.Int(student.genderId || student.genderTypeId || student.gender || student.sex);
            if (["erkek", "male", "boy"].includes(gender) || genderId === 1) return avatarStudentBoy;
            if (["kadın", "kadin", "female", "girl"].includes(gender) || genderId === 2) return avatarStudentGirl;
            return avatarStudentDefault;
        });
        const studentMeta = computed(() => {
            const student = props.data.student || {};
            const rawClass = props.data.studentClassName || student.classRoomName || student.classroomName || student.className || student.gradeName || student.schoolClassName || student.classLevel || student.classNumber || student.gradeLevel || student.schoolGrade || student.classRoom || student.classroom || student.grade;
            const rawExam = props.data.studentExamTypeName || student.lessonAreaName || student.examTypeName || student.examName || student.lessonArea || student.examType;
            const classValue = typeof rawClass === "object" ? C.Str(rawClass?.name || rawClass?.title) : C.Str(rawClass);
            const className = /^\d+$/.test(classValue) ? `${classValue}. Sınıf` : classValue;
            const examType = typeof rawExam === "object" ? C.Str(rawExam?.name || rawExam?.title) : C.Str(rawExam);
            return [className, examType].filter(Boolean).join(" · ");
        });
        const workDays = computed(() => Array.from({ length: 7 }).map((_, index) => {
            const date = D.DateAdd(Enums.DATE.DAY, index, C.Date(props.data.startDate));
            const item = (props.data.dayWorkCount || []).find(r => D.DateEqual(r.day, date));
            return { name: J.FindKey(Constants.Date.DaySortList, ((C.Date(date).getDay() + 6) % 7 + 1)), value: C.Int(item?.count) };
        }));
        const workTotal = computed(() => workDays.value.reduce((sum, day) => sum + day.value, 0));
        const workMax = computed(() => Math.max(...workDays.value.map(day => day.value), 1));
        const questionSummary = computed(() => (props.data.studentPlanList || []).reduce((sum, plan) => {
            const list = Array.isArray(plan.dayQuestionCount) ? plan.dayQuestionCount : J.Parse(plan.dayQuestionCount, "[]");
            list.forEach(item => {
                sum.correct += C.Int(item.correct);
                sum.wrong += C.Int(item.wrong);
                sum.empty += C.Int(item.empty);
            });
            return sum;
        }, { correct: 0, wrong: 0, empty: 0 }));
        const donutStyle = computed(() => {
            const total = questionSummary.value.correct + questionSummary.value.wrong + questionSummary.value.empty;
            if (!total) return { background: "conic-gradient(#e5e7eb 0 100%)" };
            const correct = questionSummary.value.correct / total * 100;
            const wrong = correct + questionSummary.value.wrong / total * 100;
            return { background: `conic-gradient(#2cc879 0 ${correct}%, #ff970f ${correct}% ${wrong}%, #cfd3da ${wrong}% 100%)` };
        });
        return { appData, C, Web, studentAvatar, studentMeta, workDays, workTotal, workMax, questionSummary, donutStyle };
    }
};
</script>

<style scoped>
.advisor-weekly-sidebar {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}

.weekly-panel-card {
    position: relative;
    min-width: 0;
    padding: 15px;
    border: 1px solid rgba(70, 45, 105, 0.08);
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 14px 34px rgba(58, 37, 88, 0.07);
}

.weekly-card-title {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 0;
    color: #24193e;
    font-size: 14px;
    font-weight: 700;
}

.weekly-card-title > svg {
    flex: none;
    width: 16px;
    height: 16px;
    overflow: visible;
}

.student-title svg {
    color: #f0a800;
}

.blue-title svg {
    color: #3478f6;
}

.purple-title svg {
    color: #7b28d8;
}

.orange-title svg {
    color: #ff7b0a;
}

.student-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
}

.student-row img {
    width: 35px;
    height: 35px;
    flex: none;
    border-radius: 13px;
    background: #f2eaff;
    object-fit: cover;
}

.student-row strong,
.student-row small {
    display: block;
}

.student-row strong {
    color: #211b35;
    font-size: 14px;
}

.student-row small {
    color: #8d8998;
    font-size: 11px;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 15px;
}

.summary-box {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    min-height: 100px;
    padding: 10px 15px;
    border-radius: 15px;
}

.summary-box > svg {
    width: 26px;
    height: 26px;
    margin-bottom: 4px;
}

.summary-box span,
.summary-box strong {
    display: block;
}

.summary-box span {
    color: #6f617d;
    font-size: 11px;
    font-weight: 500;
}

.summary-box strong {
    margin-top: 4px;
    font-size: 26px;
    line-height: 1;
}

.summary-box.purple {
    color: #8e42d8;
    background: #f4eafd;
}

.summary-box.blue {
    color: #2f86e9;
    background: #eaf4ff;
}

.summary-box.green {
    color: #29ae73;
    background: #eafaf3;
}

.summary-box.orange {
    color: #ff8a19;
    background: #fff2e6;
}

.value-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-top: 10px;
}

.metric-values {
    min-width: 0;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.metric-current {
    color: #211b35;
    font-size: 22px;
    font-weight: 750;
    letter-spacing: -0.6px;
    line-height: 1.25;
}

.metric-target {
    color: #a29aaa;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: -0.25px;
    margin-left: 5px;
}

.metric-values > small {
    display: block;
    margin-top: 2px;
    color: #9691a0;
    font-size: 11px;
}

.change {
    flex: 0 0 auto;
    max-width: 95px;
    margin-top: 2px;
    font-size: 12px;
    font-weight: 800;
    text-align: right;
}

.change small {
    display: block;
    margin-top: 5px;
    color: #8d8298;
    font-size: 11px;
    font-weight: 700;
}

.positive {
    color: #24ae72;
}

.negative {
    color: #e85d6a;
}

.bar-area {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    height: 100px;
    margin: 10px 0 7px;
    padding: 8px 8px 0;
    border-bottom: 1px solid #ececf2;
}

.bar-area span {
    flex: 1;
    max-width: 20px;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(#a86ee1, #7b28d8);
}

.day-labels {
    display: flex;
    justify-content: space-around;
    color: #908b9b;
    font-size: 10px;
}

.question-area {
    display: flex;
    align-items: center;
    gap: 22px;
    margin-top: 22px;
}

.donut {
    display: grid;
    position: relative;
    width: 104px;
    height: 104px;
    flex: none;
    place-items: center;
    border-radius: 50%;
}

.donut::after {
    position: absolute;
    inset: 15px;
    border-radius: 50%;
    background: #fff;
    content: "";
}

.donut span {
    position: relative;
    z-index: 1;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
}

.donut small {
    display: block;
    color: #9993a3;
    font-size: 10px;
    font-weight: 500;
}

.legend {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}

.legend span {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #777282;
    font-size: 12px;
}

.legend i {
    width: 8px;
    height: 8px;
    flex: none;
    border-radius: 50%;
}

.legend b {
    margin-left: auto;
    color: #292437;
}

.correct {
    background: #2cc879;
}

.wrong {
    background: #ff970f;
}

.empty {
    background: #cfd3da;
}

.work-add-btn {
    display: inline-flex;
    position: absolute;
    z-index: 5;
    top: 12px;
    right: 12px;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: #f4eafd;
    color: #8e42d8;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.2s ease;
}

.work-add-btn:hover {
    transform: translateY(-1px);
    background: #ead8fa;
}

.work-add-btn:active {
    transform: scale(0.96);
}

.work-add-btn:focus-visible {
    outline: 2px solid rgba(142, 66, 216, 0.35);
    outline-offset: 2px;
}

.work-card > .weekly-card-title {
    padding-right: 38px;
}
</style>
